import { Link, createFileRoute } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/*")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="relative h-screen w-screen bg-white">
      <img
        className="h-[90%] w-full object-contain"
        src="/public/images/notfound.png"
      />
      <div className="absolute bottom-12 left-1/2 flex -translate-x-1/2 flex-col items-center justify-center">
        <p className="text-center text-lg">
          Oops! We can&#39;t seem to find the page you&#39;re looking for.
        </p>

        <Link to="/login" className="mt-4 w-fit cursor-pointer py-4">
          <Button className="cursor-pointer"> Back to home</Button>
        </Link>
      </div>
    </div>
  );
}
